export default "__VITE_ASSET__b3554e49__"